import { BrowserDetection, useDevice } from "./BrowserDetection"

class BrowserDetails {
    private detectedDevice: BrowserDetection;
    public UserAgent: string;
    public MajorVersion: string;
    public Platform: string;
    public IsMobileDevice: boolean;
    constructor() {
        this.detectedDevice = useDevice();
        this.UserAgent = navigator.userAgent;
        this.IsMobileDevice = this.detectedDevice.isMobile || this.detectedDevice.isTablet;
        this.MajorVersion = navigator.appVersion;
        this.Platform = this.detectedDevice.isDesktop ? this.detectedDevice.desktopOS : this.detectedDevice.mobileOS;
    }
}

export { BrowserDetails }